// 

import { server } from "../redux/middleware/api"

export function getRollFromCentroid(lat: number, lng: number): Promise<string> {

    const authHeader = {
        "Authorization": window.localStorage.getItem("amptoken") as string
    }



    const requestParams: RequestInit  = {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            ...authHeader
        },
        redirect: 'follow', // manual, *follow, error
    }

    const latitude = typeof lat === 'number' ? lat : 0;
    const longitude = typeof lng === 'number' ? lng : 0;

    return new Promise((resolve, reject) => {
        fetch(`${server}/mapbox/get-roll/${latitude}/${longitude}`, requestParams)
        .then(response => response.json())
        .then(data => {
            resolve(data["roll"] as string);
        }).catch(error => {
            reject(error);
        })
    })
}

